import React, { useEffect, useRef, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Divider,
  Popover,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

const QueryTeamsPopover = ({
  anchorEl,
  teams,
  availableTeams,
  isLoadingTeams,
  onClose,
  onCommit,
}) => {
  const open = Boolean(anchorEl);
  const wasOpenRef = useRef(false);
  const [draftTeams, setDraftTeams] = useState(teams || []);

  useEffect(() => {
    if (open && !wasOpenRef.current) {
      setDraftTeams([...(teams || [])]);
    }
    wasOpenRef.current = open;
  }, [open, teams]);

  const handleApply = () => {
    onCommit(draftTeams);
    onClose();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      PaperProps={{
        sx: {
          mt: 1,
          width: { xs: 320, sm: 420 },
          border: "1px solid",
          borderColor: "divider",
        },
      }}
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="subtitle2" fontWeight={800} sx={{ mb: 0.5 }}>
          Teams
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1.5 }}>
          Find players who played for selected teams.
        </Typography>

        <Autocomplete
          multiple
          size="small"
          options={availableTeams || []}
          value={draftTeams}
          loading={isLoadingTeams}
          onChange={(_, value) => setDraftTeams(value)}
          renderInput={(params) => (
            <TextField {...params} placeholder="Search teams..." label="Teams" />
          )}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip {...getTagProps({ index })} key={option} label={option} size="small" />
            ))
          }
        />
      </Box>

      <Divider />

      <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ p: 1.5 }}>
        <Button size="small" onClick={onClose}>
          Cancel
        </Button>
        <Button size="small" variant="contained" onClick={handleApply}>
          Apply
        </Button>
      </Stack>
    </Popover>
  );
};

export default QueryTeamsPopover;
